var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkInProgress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 271,
    height: 148,
    viewBox: "0 0 271 148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_in_progress_re_m1l6",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44480",
    "data-name": "Path 44480",
    d: "M162.49,558.043a23.442,23.442,0,0,0,1.618,6.606,20.354,20.354,0,0,0,3.16,5.162,26.08,26.08,0,0,0,10.018,7.223,37.538,37.538,0,0,0,9.127,2.452c1.3-.092,2.585-.2,3.861-.315.008,0,.018,0,.026,0,.061-.006.123-.012.181-.015l.788-.074-.062.118-.193.365.209-.364c.02-.037.043-.073.064-.11a20.565,20.565,0,0,1-1.915-27.094c-.261-.079-.526-.144-.794-.2a21.7,21.7,0,0,0-1.979,3.278,21.259,21.259,0,0,0-1.834,13.226,21.736,21.736,0,0,0,5.507,10.841c-.248-.017-.5-.038-.743-.06a38.112,38.112,0,0,1-13.471-3.432,24.263,24.263,0,0,1-9.089-7.458,21.928,21.928,0,0,1-3.863-12.034,50.785,50.785,0,0,1,1.442-13.749A57.707,57.707,0,0,1,169.4,529.2a.415.415,0,0,0-.165-.548.353.353,0,0,0-.263-.054.307.307,0,0,0-.2.174c-.265.517-.525,1.035-.776,1.559a58.363,58.363,0,0,0-4.569,13.7A46.985,46.985,0,0,0,162.49,558.043Z",
    transform: "translate(-149.31 -432.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44481",
    "data-name": "Path 44481",
    d: "M223.235,713.061H116.294a.281.281,0,0,1,0-.561h106.94a.281.281,0,0,1,0,.561Z",
    transform: "translate(-116.014 -565.061)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44482",
    "data-name": "Path 44482",
    d: "M353.749,340.4,348.913,316.7l-2.124-17.5-4.706,3.044.65,19.285,7.511,19.982a2.618,2.618,0,1,0,3.5-1.117Z",
    transform: "translate(-278.8 -267.438)",
    fill: "#e6e7e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44483",
    "data-name": "Path 44483",
    d: "M219.685,345.453l1.338-24.145-.443-17.623,6.221,2.328,1.039,19.175-4.525,20.861a2.618,2.618,0,1,1-3.63-.6Z",
    transform: "translate(-189.791 -270.668)",
    fill: "#e6e7e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44484",
    "data-name": "Path 44484",
    d: "M152.924,485.673H156.1l1.512-12.261h-4.692Z",
    transform: "translate(-110 -341.014)",
    fill: "#e6e7e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44485",
    "data-name": "Path 44485",
    d: "M266.049,698.9h6.261a3.99,3.99,0,0,1,3.99,3.989v.13H266.05Z",
    transform: "translate(-223.937 -555.277)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44486",
    "data-name": "Path 44486",
    d: "M195.822,481.031l3.141.486,3.369-11.886-4.636-.717Z",
    transform: "translate(-141.002 -337.779)",
    fill: "#e6e7e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44487",
    "data-name": "Path 44487",
    d: "M307.932,693.488l6.187.957h0A3.99,3.99,0,0,1,317.452,699l-.02.128-10.13-1.567Z",
    transform: "translate(-253.754 -551.386)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44488",
    "data-name": "Path 44488",
    d: "M235.094,456.5l-.016-.089-11.508-62.22a23.5,23.5,0,0,1,2.077-14.7l6.965-13.931L253.4,368.38l2.453,17.736,8.741,33.834-.009.028-11.2,35.574-7.34.483,6.5-31.755-11.905-27.04.84,58.779Z",
    transform: "translate(-193.105 -315.505)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44489",
    "data-name": "Path 44489",
    d: "M267.067,299.951l-.137-.215c-.025-.039-2.549-3.842-9.419-1.3-7.013,2.593-12.447-2.415-12.5-2.466l-.027-.025-1.588-14.156-1.875-11.492,5.968-1.047,2.934-1.76,11.668-.208,3.07,2.415,5.041.549.461,10.471,0,.011Z",
    transform: "translate(-206.291 -244.419)",
    fill: "#585d67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44490",
    "data-name": "Path 44490",
    d: "M338.5,289.141v-8.966l1.418-2.587.058,0a4.25,4.25,0,0,1,2.936,1.334c1.426,1.449,2.072,3.862,1.92,7.174l0,.061Z",
    transform: "translate(-276.214 -251.83)",
    fill: "#585d67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44491",
    "data-name": "Path 44491",
    d: "M231.8,288.338l-7.225-.867-.006-.083c-.247-3.6.382-6.278,1.869-7.949a4.583,4.583,0,0,1,2.961-1.612l.042,0L231.4,279.6Z",
    transform: "translate(-194.063 -252.001)",
    fill: "#585d67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44492",
    "data-name": "Path 44492",
    d: "M272.479,204.841H253.466a1.477,1.477,0,0,1-1.475-1.475v-6.884a10.982,10.982,0,1,1,21.963,0v6.884A1.477,1.477,0,0,1,272.479,204.841Z",
    transform: "translate(-213.824 -185.5)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2606",
    "data-name": "Ellipse 2606",
    cx: 8.051,
    cy: 8.051,
    r: 8.051,
    transform: "translate(38.663 14.425) rotate(-61.337)",
    fill: "#e6e7e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44493",
    "data-name": "Path 44493",
    d: "M277.956,200.961h-10.63a.821.821,0,0,1-.813-.718l-.138-1.1a.492.492,0,0,0-.934-.147l-.7,1.493a.823.823,0,0,1-.743.473h-1.615a.819.819,0,0,1-.816-.9l.637-6.65a.826.826,0,0,1,.468-.667,16.622,16.622,0,0,1,14.673.009.821.821,0,0,1,.464.629l.954,6.641a.819.819,0,0,1-.811.936Z",
    transform: "translate(-220.825 -189.488)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44494",
    "data-name": "Path 44494",
    d: "M266.7,133.512l-.4-.4,17.251-17.252h33.432l16.868-17.216h33L383.5,81.869h77.5v.561H383.738L367.089,99.209h-33l-16.868,17.216H283.789Z",
    transform: "translate(-192.251 -59.004)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2607",
    "data-name": "Ellipse 2607",
    cx: 10.385,
    cy: 10.385,
    r: 10.385,
    transform: "translate(132.109 29.64)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2608",
    "data-name": "Ellipse 2608",
    cx: 2.807,
    cy: 2.807,
    r: 2.807,
    transform: "translate(188.96 20.49)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2609",
    "data-name": "Ellipse 2609",
    cx: 2.807,
    cy: 2.807,
    r: 2.807,
    transform: "translate(265.386 20.49)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2610",
    "data-name": "Ellipse 2610",
    cx: 2.807,
    cy: 2.807,
    r: 2.807,
    transform: "translate(227.214 20.49)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44495",
    "data-name": "Path 44495",
    d: "M597.652,311.832a10.666,10.666,0,1,1,10.666-10.666A10.666,10.666,0,0,1,597.652,311.832Zm0-20.771a10.1,10.1,0,1,0,10.1,10.1A10.1,10.1,0,0,0,597.652,291.061Z",
    transform: "translate(-455.158 -261.14)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2611",
    "data-name": "Ellipse 2611",
    cx: 7.42,
    cy: 7.42,
    r: 7.42,
    transform: "translate(135.074 32.6)",
    fill: "#585d67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44496",
    "data-name": "Path 44496",
    d: "M500.762,138.121l-2.221-2.856,1.291-1,1.052,1.352,3.552-3.75,1.188,1.126Z",
    transform: "translate(-358.976 -94.977)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2612",
    "data-name": "Ellipse 2612",
    cx: 10.385,
    cy: 10.385,
    r: 10.385,
    transform: "translate(81.165 46.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44497",
    "data-name": "Path 44497",
    d: "M415.652,372.832a10.666,10.666,0,1,1,10.666-10.666A10.666,10.666,0,0,1,415.652,372.832Zm0-20.771a10.1,10.1,0,1,0,10.1,10.1A10.1,10.1,0,0,0,415.652,352.061Z",
    transform: "translate(-324.101 -305.083)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2613",
    "data-name": "Ellipse 2613",
    cx: 7.42,
    cy: 7.42,
    r: 7.42,
    transform: "translate(84.128 49.66)",
    fill: "#585d67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44498",
    "data-name": "Path 44498",
    d: "M318.762,199.121l-2.221-2.856,1.291-1,1.052,1.352,3.552-3.75,1.188,1.126Z",
    transform: "translate(-227.926 -138.913)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkInProgress);
export default __webpack_public_path__ + "static/media/work_in_progress.b35bbd0011800e6914ae653a044fb739.svg";
export { ForwardRef as ReactComponent };